module.exports = __webpack_public_path__ + "assets/img/CMTP-Website-w960.452fe910.jpg";